import * as React from 'react';
import DependentStep from './dependentStep';
import PersonalStep from './personalStep';
import SpouseStep from './spouseStep';

export interface IEditPersonalDetailsProps {}
interface ProfileUserContextType {
  activeStep: string;
  setActiveStep: any;
}

export const ProfileUser = React.createContext<ProfileUserContextType>({
  activeStep: 'Personal',
  setActiveStep: () => {},
});
export default function EditPersonalDetails(props: IEditPersonalDetailsProps) {
  const [activeStep, setActiveStep] = React.useState('Personal');
  let value = {
    activeStep,
    setActiveStep,
  };
  return (
    <div className="p-4">
      <ProfileUser.Provider value={value}>
        <div className="grid grid-cols-8 gap-5 h-12 md-max:mb-16 md-max:gap-0  md-max:grid-cols-9 ">
          <div className=" col-span-2 font-bold text-medium md-max:col-span-9 md-max:pb-6">
            Personal Details
          </div>

          <div
            className=" col-span-2 mb-4 inline-flex gap-2 text-gray-700 font-semibold  cursor-pointer md-max:text-xs md-max:col-span-3 md-max:grid md-max:gap-0 md-max:items-center m "
            onClick={() => setActiveStep('Personal')}
          >
            <span
              className={`border rounded-full h-8 w-8 pt-1 text-center md-max:p-3 md-max:pt-1 md-max:justify-self-center  md-max:text-base  ${
                activeStep === 'Personal'
                  ? 'bg-green text-white border-green'
                  : 'border-gray-700  text-gray-700'
              }`}
            >
              1
            </span>
            <span
              className={`mt-1  md-max:text-center ${
                activeStep === 'Personal' ? ' text-green ' : '  text-gray-700'
              }`}
            >
              Personal Information
            </span>
          </div>
          <div
            className=" col-span-2 mb-4 inline-flex gap-2 text-gray-700 font-semibold  cursor-pointer md-max:text-xs md-max:col-span-3 md-max:grid md-max:gap-0"
            onClick={() => setActiveStep('Spouse')}
          >
            <span
              className={`border rounded-full h-8 w-8 pt-1 text-center md-max:p-3 md-max:pt-1  md-max:justify-self-center md-max:text-base md-max:pl-2.5	 ${
                activeStep === 'Spouse'
                  ? 'bg-green text-white border-green'
                  : 'border-gray-700  text-gray-700'
              }`}
            >
              2
            </span>
            <span
              className={`mt-1 md-max:text-center ${
                activeStep === 'Spouse' ? ' text-green ' : '  text-gray-700'
              }`}
            >
              Spouse Information
            </span>
          </div>
          <div
            className=" col-span-2 mb-4 inline-flex gap-2 text-gray-700 font-semibold  cursor-pointer md-max:text-xs  md-max:col-span-3 md-max:grid md-max:gap-0"
            onClick={() => setActiveStep('Dependent')}
          >
            <span
              className={`border rounded-full h-8 w-8 pt-1 text-center md-max:p-3 md-max:pt-1 md-max:justify-self-center  md-max:text-base md-max:pl-2.5  ${
                activeStep === 'Dependent'
                  ? 'bg-green text-white border-green'
                  : 'border-gray-700  text-gray-700'
              }`}
            >
              3
            </span>
            <span
              className={`mt-1 md-max:text-center ${
                activeStep === 'Dependent' ? ' text-green ' : '  text-gray-700'
              } `}
            >
              Dependent Information
            </span>
          </div>
        </div>
        <hr className="pb-6 xl-max:mt-4 md-max:mt-20" />
        <div>
          {activeStep === 'Personal' && <PersonalStep />}
          {activeStep === 'Spouse' && <SpouseStep />}{' '}
          {activeStep === 'Dependent' && <DependentStep />}{' '}
        </div>
      </ProfileUser.Provider>
    </div>
  );
}
